/* eslint-disable no-console */
import { Inject, Injectable } from '@angular/core';
import { CheckinAppConstants } from '@src/components/routing/ib-check-in-constants';
import { ApisFormProps } from 'commercial-management--digital--web-components-design--library';
import { AJSRootScope, CommonsSessionStorageService } from 'ib-web-commons/utils';
import { IbCheckinApisModelTransformerService } from '../../../services/ib-checkin-apis-model-transformer.service';
import { ApisPassenger, FormDataChecksAllPassengers } from '@src/app/core/models/ib-checkin-apis/ib-checkin-apis.model';
import { FormAdditionalInfo, ModelAdditionalInfo } from 'commercial-management--digital--web-components-design--library/dist/components/layout/ApisForm/components/ContactData/AdditionalInfo/AdditionalInfo.model';
import { FormEmergencyInfo, ModelEmergencyInfo } from 'commercial-management--digital--web-components-design--library/dist/components/layout/ApisForm/components/ContactData/EmergencyInfo/EmergencyInfo.model';
import { FormPassengerAddress, ModelPassengerAddress } from 'commercial-management--digital--web-components-design--library/dist/components/layout/ApisForm/components/PassengerAddress/PassengerAddress.model';

@Injectable({ providedIn: 'root' })
export class IbCheckinApisFormService {
    constructor (
        @Inject(AJSRootScope) private $rootScope,
        private ApisModelTransformerService: IbCheckinApisModelTransformerService,
        private CommonsSessionStorageService: CommonsSessionStorageService
    ) {}

    getApisFormProps (passenger: ApisPassenger, onSubmitApisForm, isMultiPassengers: boolean): ApisFormProps {
        const apisInfo: any = this.CommonsSessionStorageService.get(CheckinAppConstants.STORAGE_KEYS.APIS_INFO);
        const apisFormProps: ApisFormProps = {
            id: passenger.id.toLocaleString(),
            listNationalities: apisInfo.countries,
            listCountries: apisInfo.countries,
            countryCodes: apisInfo.prefixList,
            listStates: apisInfo.states,
            market: this.$rootScope.appMarket,
            model: this.ApisModelTransformerService.setApisFormModel(passenger),
            onSubmit: onSubmitApisForm,
            isMultiPassengers: isMultiPassengers
        };
        return apisFormProps;
    }

    transformerCheckAllPassengers (formData: FormDataChecksAllPassengers, props: ApisFormProps) {
        if (props?.model) {
            const model = props.model;
            if (formData?.additionalInfo) {
                model.contactData.additionalInfo = this.getAdditionalInfo(formData.additionalInfo, model.contactData.additionalInfo);
            }
            if (formData?.emergencyInfo) {
                model.contactData.emergencyInfo = this.getEmergencyInfo(formData.emergencyInfo, model.contactData.emergencyInfo);
            }
            if (formData?.passengerAddress) {
                model.passengerAddress = this.getPassengerAddress(formData.passengerAddress, model.passengerAddress);
            }
        }
        return props;
    }

    private getAdditionalInfo (additionalInfo: FormAdditionalInfo, modelAdditionalInfo: ModelAdditionalInfo): ModelAdditionalInfo {
        const { email, phone, number } = additionalInfo;
        modelAdditionalInfo.checkInfoAll = true;
        modelAdditionalInfo.email.value = email;
        modelAdditionalInfo.number.value = number;
        modelAdditionalInfo.phone.value = phone.value;
        return modelAdditionalInfo;
    }

    private getEmergencyInfo (emergencyInfo: FormEmergencyInfo, modelEmergencyInfo: ModelEmergencyInfo): ModelEmergencyInfo {
        const { name, phone, number } = emergencyInfo;
        modelEmergencyInfo.checkEmergencyAll = true;
        modelEmergencyInfo.name.value = name;
        modelEmergencyInfo.number.value = number;
        modelEmergencyInfo.phone.value = phone.value;
        return modelEmergencyInfo;
    }

    private getPassengerAddress (passengerAddress: FormPassengerAddress, modelPassengerAddress: ModelPassengerAddress): ModelPassengerAddress {
        const { address, zipCode, city, state } = passengerAddress;
        modelPassengerAddress.checkAddressForAll = true;
        modelPassengerAddress.address.value = address;
        modelPassengerAddress.zipCode.value = zipCode;
        modelPassengerAddress.city.value = city;
        modelPassengerAddress.state.value = state.value;
        return modelPassengerAddress;
    }
}
